'use strict';

var formValidation = require('../components/formValidation');
var phoneCountryCode = require('../components/phoneCountryCode');
const { showToastMessage } = require('../../js/components/toast');

function displayProfileUpdateSuccessMessage() {
    const message = document.querySelector('.js-profile-card')?.getAttribute('data-update-success-message');
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    if (searchParams.get('updateSuccess') === 'true' && message) {
        showToastMessage({
            message: message,
            alertType: 'alert-success',
            disableCloseButton: false
        });

        searchParams.delete('updateSuccess');
        window.history.replaceState({}, document.title, url.toString());
    }
}

module.exports = {
    init: function () {
        phoneCountryCode.init();
        displayProfileUpdateSuccessMessage();
    },
    submitProfile: function () {
        $('form.edit-profile-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();

            var url = $form.attr('action');
            $form.spinner().start();
            $('form.edit-profile-form').trigger('profile:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        const base = data.redirectUrl;
                        const separator = base.includes('?') ? '&' : '?';
                        window.location.href = base + separator + 'updateSuccess=true';
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
        });
    },

    submitPassword: function () {
        $('form.change-password-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();

            var url = $form.attr('action');
            $form.spinner().start();
            $('form.change-password-form').trigger('password:edit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
        });
    }
};
